import React, { Suspense } from 'react'
import { ThemeProvider } from 'react-jss'
import { LoadingComponent } from '../../components/loading/index'
import mainTheme from '../../theme'

const CancelSubscriptionLayout = React.lazy(() => import('./cancel-subscription-layout'))

const AsyncCancelSubscriptionLayout = props => {
  return (
    <ThemeProvider theme={mainTheme}>
      <Suspense fallback={<LoadingComponent />}>
        <CancelSubscriptionLayout {...props} />
      </Suspense>
    </ThemeProvider>
  )
}

export default AsyncCancelSubscriptionLayout
